import Contact from 'edge/fnol/common/models/Contact';

export default class MedicalTreatmentCtrl {
    addDoctor() {
        this.workersComp.firstIntakeDoctor = new Contact({subtype: 'Doctor'});
    }

    removeDoctor() {
        this.workersComp.firstIntakeDoctor = null;
    }
}